module.exports = __webpack_public_path__ + "static/media/weddingDress.b946db9c.png";